export enum AppointmentNotificationType {
  Created = 0,
  Updated = 1,
  Cancelled = 2,
  Reminder = 3
}

export const AppointmentNotificationTypeLabels: Record<AppointmentNotificationType, string> = {
  [AppointmentNotificationType.Created]: 'Created',
  [AppointmentNotificationType.Updated]: 'Updated',
  [AppointmentNotificationType.Cancelled]: 'Cancelled',
  [AppointmentNotificationType.Reminder]: 'Reminder'
};
